
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import getEquipment from "../../services/equipment/getEquipment";
import FichaTecnica from "./FichaTecnica";
import OtmPcoman from "./OtmPcoman";
import OtmSismac from "./OtmSismac";
import Alert from "../../alert/Alert";
import LoaderEquipment from "../../loaders/LoaderEquipment";
import CriteriosReposicion from "./CriteriosReposicion";
import GaleriaImagenes from "./GaleriaImagenes";
import AnalisisMeta from "./AnalisisMeta";

const FichaTabs = ({ setTitulo }) => {
    const { codigo } = useParams()
    const [Equipment, setEquipment] = useState([])

    useEffect(() => {

        getEquipment([codigo]).then((data) => {

            if (data.resultado === "ok") {
                setTitulo(codigo + " - " + data.denominacion.toUpperCase());
                setEquipment(data);
            }
        });
    }, [codigo]);

    return (

        (Equipment.codigoPatrimonial == null) ? <LoaderEquipment /> : (

            <>
                {
                    (Equipment.fechaBaja != null) && (
                        <Alert color="danger">
                            <div className="text-center">
                                <h1><i className="fas fa-exclamation-triangle"></i> </h1>
                                <h5>Equipo de baja.</h5>
                                <div>
                                    Fecha de la resolución de baja: {
                                        // Formato de fecha : dd/mm/yyyy
                                        (Equipment.fechaBaja.split("T")[0]).split("-").reverse().join("/")
                                    }
                                </div>
                            </div>
                        </Alert>
                    )
                }
                <div className="tab-content" id="nav-tabContent">
                    <div className="tab-pane fade active show" id="ficha-tecnica" role="tabpanel" aria-labelledby="ficha-tecnica-tab">
                        <div className="row">
                            <div className="col-lg-4 col-md-6 order-sm-1">
                                <FichaTecnica data={Equipment} />
                            </div>

                            <div className="col-lg-4 col-md-6 order-sm-2">
                                <GaleriaImagenes codigo={Equipment.codigoPatrimonial} />
                                <CriteriosReposicion data={Equipment} />
                            </div>

                            <div className="col-lg-4 col-md-12 order-sm-3">
                                <AnalisisMeta codigo={Equipment.codigoPatrimonial} />
                            </div>
                        </div>
                    </div >
                    <div className="tab-pane fade " id="otm-sismac" role="tabpanel" aria-labelledby="otm-sismac-tab">
                        <h3 className="pl-2 m-0 mb-3 d-none d-print-block ">{Equipment.codigoPatrimonial} : {Equipment.denominacion}</h3>
                        <OtmSismac codigo={Equipment.codigoPatrimonial} />
                    </div>
                    <div className="tab-pane fade" id="otm-pcoman" role="tabpanel" aria-labelledby="otm-pcoman-tab">
                        <h3 className="pl-2 m-0 mb-3 d-none d-print-block">{Equipment.codigoPatrimonial} : {Equipment.denominacion}</h3>
                        <OtmPcoman codigo={Equipment.codigoPatrimonial} />
                    </div>
                    <div className="tab-pane fade" id="repuestos" role="tabpanel" aria-labelledby="repuestos-tab">
                        <p className="text-center">
                            <img className="" style={{ maxWidth: "200px" }} src={`${process.env.REACT_APP_BASE_URL}/theme/dist/img/AdminLTELogo.png`} alt="En construcción" />
                            <br />
                            <span>EN CONSTRUCCIÓN</span>
                        </p>
                    </div>
                </div >
            </>
        )
    )
}
export default FichaTabs